import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    institutionsTree:[],

    isToken:false,
  },
  mutations: {
    getList(state,info){
      state.institutionsTree = info;
    }
  },
  actions: {
  },
  modules: {
  }
})
